import { Component, OnInit } from '@angular/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
  selector: 'lib-rt-outbound-by-fleet-report',
  templateUrl: './rt-outbound-by-fleet-report.component.html',
  styleUrls: ['./rt-outbound-by-fleet-report.component.css']
})
export class RtOutboundByFleetReportComponent implements OnInit {

    public gridId = 122;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Outbound At Customer By Fleet Report';

  constructor() { }

  ngOnInit(): void {
  }

}
